import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, DialogContent, IconButton, Fab, Tooltip } from '@mui/material';
import { PersonAdd as PersonAddIcon, Close as CloseIcon } from '@mui/icons-material';
import { useSnackbar } from '@contexts/SnackbarContext';
import API from '@utils/axios';
import ContactForm from './ContactForm';
import { formError } from '@utils/helpers';

const ContactCreationForm = ({ mailingListId, onCreated }) => {
    const { t } = useTranslation();
    const { showMessage } = useSnackbar();
    const [open, setOpen] = useState(false);
    const formRef = useRef();

    const handleSubmit = async (data) => {
        try {
            const response = await API.post(`/mailing-lists/${mailingListId}/contacts`, [data]);
            showMessage(t('Contact created successfully'), 'success');
            if (response.data.warnings && response.data.warnings.length > 0) {
                response.data.warnings.forEach((item) => {
                    showMessage(t(item.message) + ' : "' + item.value + '".'
                            + (item.message2 ? ' ' + t(item.message2) : ''), 'warning');
                });
            }
            setOpen(false);
            if (onCreated) {
                onCreated();
            }
        } catch (error) {
            formError(error, t, formRef.current.setError, showMessage);
        }
    };

    return (
        <>
            <Tooltip title={t('Add contact')} placement="top" arrow>
                <Fab 
                    color="primary" 
                    aria-label={t('Add contact')}
                    className="main-fab" 
                    sx={{ boxShadow: 6 }}
                    onClick={() => setOpen(true)}
                >
                    <PersonAddIcon />
                </Fab>
            </Tooltip>

            <Dialog 
                open={open} 
                onClose={() => setOpen(false)}
                aria-labelledby="contact-creation-dialog"
            >
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogTitle>
                    {t('Add contact')}
                </DialogTitle>
                <DialogContent sx={{ width: '500px' }}>
                    <ContactForm
                        ref={formRef}
                        onSubmit={handleSubmit}
                        showInfoMessage={true}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ContactCreationForm; 